import Vue from 'vue'
import Vuex from 'vuex'
import utils from '../utils/common.js'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    userInfo: {},
    currentFormGroup: {},
    isShowLogin: false,
    isShowLoading: false,
    loadingText: '',
    wxLoginState: '',
    isShowDialog: false,
    dialogTitle: '',
    dialogContent: '',
    tabbarSelected: 0
  },
  getters: {
    getUserInfo (state) {
      return state.userInfo
    },
    getCurrentFormGroup (state) {
      return state.currentFormGroup
    },
    getIsLogin (state) {
      return !utils.isEmptyObject(state.userInfo)
    },
    getIsShowLogin (state) {
      return state.isShowLogin
    },
    getWxLoginState (state) {
      return state.wxLoginState
    },
    getIsShowLoading (state) {
      return state.isShowLoading
    },
    getLoadingText (state) {
      return state.loadingText
    },
    getIsShowDialog (state) {
      return state.isShowDialog
    },
    getDialogTitle (state) {
      return state.dialogTitle
    },
    getDialogContent (state) {
      return state.dialogContent
    },
    getTabbarSelected (state) {
      return state.tabbarSelected
    }
  },
  mutations: {
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
    },
    setCurrentFormGroup (state, currentFormGroup) {
      state.currentFormGroup = currentFormGroup
    },
    setShowLogin (state, isShowLogin) {
      state.isShowLogin = isShowLogin
    },
    setWxLoginState (state, wxLoginState) {
      state.wxLoginState = wxLoginState
    },
    setIsShowLoading (state, params) {
      state.isShowLoading = params.isShowLoading
      state.loadingText = params.loadingText
    },
    setIsShowDialog (state, params) {
      state.isShowDialog = params.isShowDialog
      state.dialogTitle = params.dialogTitle
      state.dialogContent = params.dialogContent
    },
    setTabbarSelected (state, index) {
      state.tabbarSelected = index
    }
  },
  actions: {
    setUserInfo ({ commit }, user) {
      commit('setUserInfo', user)
    },
    setCurrentFormGroup ({ commit }, currentFormGroup) {
      commit('setCurrentFormGroup', currentFormGroup)
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/user.js